import styled from "styled-components";

export const AuthBlock = styled.section`
background-color: var(--background);
width:100%;
display: grid;
grid-template-columns: 50% 50%;
padding: 40px;

justify-items: center; 
align-items: center;
min-height: 100vh;
min-height: 100svh;

@media screen and (max-width: 1239px) {
  grid-template-columns: 1fr;
  height: 100%;
  background: 
      url("/i/loginHills.svg") no-repeat right,
      url("/i/loginletter.svg") no-repeat top left,
      url("/i/loginLoop.svg") no-repeat left bottom;
  background-size: auto 84px, auto 131px, auto 147px;
}

@media screen and (max-width: 767px) {
  padding: 16px;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  background: none;
}

@media (max-height: 750px) {
        // padding: 5vh;
}
`;

export const AuthSection1 = styled.div`
  max-height: min-content;
  margin: auto;


  @media screen and (max-width: 1239px) {
    background-color: rgba(255, 255, 255, 0.8);
    max-width:calc(100% - 20px);
    width: 100%;
    height:100%;
    border-radius:10px;
    display: flex;
    align-items:center;
    justify-content: center;
    padding: 60px;
  }
@media screen and (max-width: 767px) {
  padding: 30px;
}

`;
export const AuthSection2 = styled.div`
  max-height: min-content;
  margin: auto;

  @media screen and (max-width: 1239px) {
    display: none;
  }
`;

export const AuthForm = styled.div`
  width: 372px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media screen and (max-width: 1239px) {
    width: 440px;
    margin:auto;
  }

  @media screen and (max-width: 767px) {
    width: calc(100vw - 92px);
  }
`;
export const AuthHeader = styled.h1`
  font-size: 46px;
  text-align: left;
  font-weight: 900;

  @media screen and (max-width: 1239px) {
    font-size: 46px;
    text-align: center;
  }
  @media screen and (max-width: 767px) {
    font-size: 32px;
    margin-bottom: 5px;

  }
`;
export const AuthHeader2 = styled.div`
  font-size: 1.3rem;
  text-align: center;
  margin-bottom: 5vh;
  font-weight: 500;
  color: var(--disabled-c);
  text-wrap: nowrap;

  @media screen and (max-width: 1239px) {
    font-size: 20px;
    margin-bottom: 7vh;
    text-wrap: wrap;
    text-align: center;
  }
  @media screen and (max-width: 767px) {
    font-size: 16px;
    margin: auto;
    width: 220px;
    margin-bottom: 45px;
  }
`;

export const InputContainer = styled.div`
  align-items: center;
  border-radius: 10px;
  display: flex;
  overflow: hidden;
  height: 46px;
`;

export const Input = styled.input`
background-color: transparent;
  border: ${(props) =>
    props.$activeinput
      ? "1px solid var(--blue)" 
      : "1px solid var(--disabled-c)"};

  border-radius: 10px;
  overflow: hidden;
  height: 46px;
  font-family: "Mulish", sans-serif;
  width: 100%;
  maxlength: 50;

  font-size: 14px;
  padding: 0 14px;

  &&::placeholder {
    color: var(--roman-silver);
    display: inline;
    font-family: "Mulish", sans-serif;
    font-size: 14px;
  }
  &:disabled::placeholder {
    color: var(--disabled-c);
  }
  @media screen and (max-width: 767px) {
    font-size: 12px;
    &&::placeholder {
      font-size: 12px;
    }
  }
`;

export const SecondaryText = styled.div`
  color: ${(props) => props.color || "var(--black)"};
  text-align: ${(props) => props.$textAlign || "left"};
  font-size: ${(props) => props.$fontSize || "12px"};
  margin: ${(props) => props.$margin || "0 0"};
  font-family:  ${(props) => props.$fontFamily || "Mulish"}, sans-serif;

  @media screen and (max-width: 767px) {
    font-size: 12px;
  }
`;

export const ErrorSpan = styled.div`
  color: var(--red);
  height: 1px;
  margin-top: ${(props) => props.$marginTop || "-22px"};
  font-size: 12px;
  line-height: 1;
  margin-bottom: 2px;
`;

export const RedFile = styled.u`
  &:hover {
    cursor: pointer;
  }
  color: red;
  margin-left: auto;
`;

export const LabelLogo = styled.label`
  position: relative;
  background-color: var(--black);
  display: block;
  height: 100%;
  width: 46px;
  @media screen and (max-width: 767px) {
    width: 46px;
  }
  ${(props) => props.disabled && `background-color: var(--disabled-c)`}

  background-color: ${(props) =>
    props.error ? `var(--red) ` : `var(--black)`};
`;

export const VisibilityStyles = styled.svg`
  position: absolute;
  color: var(--black);
  right: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  width: 24px;
  height: 100%;
`;
